exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".long___1Qu7X {\n  background: #eee;\n  border-radius: 6px;\n  height: 10px;\n  width: 250px;\n}\n.short___3IOOJ {\n  background: #eee;\n  border-radius: 6px;\n  height: 10px;\n  margin-top: 12px;\n  width: 214px;\n}\n", ""]);

// exports
exports.locals = {
	"long": "long___1Qu7X",
	"short": "short___3IOOJ"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"modules":true,"localIdentName":"[local]___[hash:base64:5]"}!./node_modules/less-loader/dist/cjs.js!./src/components/manage/VirtualEvents/common/FormPlaceholer/FormPlaceholder.module.less
// module id = 2345
// module chunks = 51